/**
 * Javascript file for the page to access and view the results of the AI readiness check.
 * @author Yannik Sprengart, Andrea Villeda.
 */

import TextCard from "../../kirc/components/TextCard.vue";
import RecCard from "../../kirc/components/RecommendationCard.vue";
import ScoreCard from "../../kirc/components/ScoreCard.vue";
import auth from "../../../../auth";
import { getKIRCResult2 } from "../../../../api";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "KIRCRes2",
  components: {
    TextCard,
    RecCard,
    ScoreCard,
    Loading,
  },

  /**
   * The vue instance's data object.
   * @property {boolean} loggedIn - Status of the user's login. 
   * @property {any} keys - The keys for the different sections of the result page.
   * @property {string} code - The result code of the AI readiness check.
   * @property {any} rec - The "recommendation" attribute.
   * @property {boolean} isLoading - Information is being loaded.
   * @property {number} finalScore - The final score for the AI readiness check.
   * @property {boolean} error - There has been an error.
   * @property {boolean} showResult - Visibilty of the result of the AI readiness check.
   * @property {any} level1- The first possible level of AI readiness, called "Novize".
   * @property {any} level2- The second possible level of AI readiness, called "Erkunder".
   * @property {any} level3- The third possible level of AI readiness, called "Entdecker".
   * @property {any} level4- The fourth possible level of AI readiness, called "Vorbereiter".
   * @property {any} level5- The fifth possible level of AI readiness, called "Anwender".
   * @property {any} recEvents - The recommended events.
   * @property {any} recTrainer - The recommended trainers.
   * @property {any} kircResText - The recommended trainers.
   */
  data() {
    return {
      loggedIn: auth.loggedIn(),
      keys: [],
      code: "",
      rec: null,
      isLoading: false,
      finalscore: 0,
      error: false,
      showResult: false,
      level1: {
        name: "Novize",
        text:
          "Voraussetzungen für den Einsatz von KI-Anwendungen sind noch keine erfüllt. Es wurden noch keine KI-Anwendungsszenarien identifiziert. Das Thema KI wird im Unternehmen noch nicht wahrgenommen, auch über eine KI-Strategie hat man sich noch keine Gedanken gemacht. Daten werden in der Regel nur vereinzelt digital erfasst.",
      },
      level2: {
        name: "Erkunder",
        text:
          "Voraussetzungen für den Einsatz von KI-Anwendungen wurden identifiziert und Potenziale möglicher Anwendungen wurden erkannt. Die Mitarbeiter des Unternehmens beginnen sich für das Thema KI zu interessieren. Perspektivisch soll eine KI-Strategie eingeführt werden. Daten werden in der Regel noch unstrukturiert und dezentral erfasst. Notwendige Kompetenzen zum Umgang mit KI-Anwendungen wurden identifiziert.",
      },
      level3: {
        name: "Entdecker",
        text:
          "Maßnahmen zur Erfüllung der Voraussetzungen für die KI-Einführung wurden identifiziert. Konkrete Anwendungsszenarien wurden bereits erfasst und die Bereitschaft von Mitarbeitern KI-Projekte mitzutragen ist vereinzelt gegeben. Eine KI-Strategie ist in Planung. Daten werden bereits strukturiert, aber dezentral, erfasst. Die Mitarbeiter des Unternehmens werden beim Kompetenzaufbau im Bereich KI unterstützt.",
      },
      level4: {
        name: "Vorbereiter",
        text:
          "Maßnahmen, um die Voraussetzungen für KI-Anwendungen zu erfüllen wurden ergriffen. Es wurden konkrete Lösungsansätze für die identifizierten Anwendungsszenarien beschlossen. Die Bereitschaft der Mitarbeiter KI-Projekte mitzugestalten ist vorhanden und die Planung einer KI-Strategie ist abgeschlossen. Daten werden in der Regel zentral und größtenteils strukturiert erfasst. Ein erweitertes Angebot für den Kompetenzaufbau der Mitarbeiter ist vorhanden und wird gegebenenfalls durch die Akquise neuer Mitarbeiter unterstützt.",
      },
      level5: {
        name: "Anwender",
        text:
          "Die Voraussetzungen für den Einsatz von KI-Anwendungen sind erfüllt und die Umsetzung vereinzelter Anwendungsszenarien läuft. Die Mitarbeiter des Unternehmens sind motiviert KI-Projekte voranzutreiben. Die Umsetzung der KI-Strategie ist bereits angelaufen. Daten werden zentral gespeichert und es werden erste Analysen durchgeführt. Ein individueller Kompetenzaufbau im Bereich KI wird gefördert.",
      },
      recEvents: [],
      recTrainer: [],
      recScores: null,
      kircResText: "",
      resulttoken: null,
      isNew: true,
      catVisibilities: {
        "Technologie": true,
        "Organisation": false,
        "Umwelt": false,
        "Menschen": false,
      }
    };
  },

  /**
   * Called after the instance has been created.
   */
  created() {
    this.isLoading = true;
    this.isLoading = false;
    this.keys[0] = "Technologie";
    this.keys[1] = "Organisation";
    this.keys[2] = "Umwelt";
    this.keys[3] = "Menschen";
    this.keys[4] = "abschließende Fragen";
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Gets the result of the AI readiness check.
     */
    toggleCat(cat){
      this.catVisibilities[cat] = !this.catVisibilities[cat];
    },
    isVisibleCat(cat){
      return this.catVisibilities[cat];
    },
    checkIfOldAndReroute(){
      if(this.isNew === false){
        console.log("This is an old KIRC. Re-routing to old KIRC result page.");
        this.$router.push({ name: "KIRCResOld" , params: { code: this.code, showResult: true }});
      }
    },
    checkIfOldAndScale(){
      if(this.isNew === false){
        let maxscore = 168.1;
        this.scaledScore = this.finalscore / 322.0 * maxscore;
        this.level = parseFloat(this.scaledScore / maxscore * 5.0).toFixed(2);
      }
    },
    /* sort answer instances by index */
    sortByIndex(){
      this.answerInstance = this.answerInstances.sort(function(a,b){
        var x = a.index;
        var y = b.index;
        return ((x<y) ? -1 : ((x>y)?1:0));
      });
    },
    getResult() {
      if (this.code.length > 5) {
        this.isLoading = true;
        getKIRCResult2(this.code)
          .then((res) => {
            console.log("Loaded the result from the server.");
            if(res){
              console.log(JSON.stringify(res));
            } else {
              console.error("No response from server for KIRC Result.");
            }
            this.finalscore = res.score;
            this.level = res.level;
            if(res.isNew === ('undefined' || null)){
              this.isNew = false;
            } else {
              this.isNew = res.isNew;
            }
            //if this result is an old one, re-route to old result page
            //this.checkIfOldAndScale(); //or use the alternative and reroute to the old result page
            this.checkIfOldAndReroute();
            //console.log(res);
            let newrec = {};
            for (var key of Object.keys(res.rec)) {
              let newkey = key.replace(", ", "");
              if (
                key !==
                "Wirtschaftliche Perspektive, Produkte und Dienstleistungen"
              )
                newrec[newkey] = res.rec[key];
              else newrec[key] = res.rec[key];
            }
            this.recEvents = res.recevents;
            this.recTrainer = res.reckitrainers;
            this.rec = newrec;
            this.kircResText = res.kircResText;
            //this.finalscore=res.score;
            this.showResult = true;
            this.isLoading = false;
            //new stuff after loading
            this.subLevels = res.sublevels;
            this.subScores = res.subscoresPerLevel;
            this.levelIndustry = res.avgPerIndustry; 
            this.levelSize = res.avgPerSize; 
            this.newkirc = res.isNew;
            this.amountCompaniesComparison = res.numKIRCs;
            this.answerInstances = res.answerInstances;
            this.sortByIndex();
            //console.log("Received the following answer instances from backend: " + JSON.stringify(this.answerInstances));
            //TODO remove hacks
            if(this.levelIndustry === ('undefined' || null)){
              this.levelIndustry = 3;
            }
            if(this.levelSize === ('undefined' || null)){
              this.levelSize = 3;
            }
            if(this.amountCompaniesComparison === ('undefined' || null)){
              this.amountCompaniesComparison = 0;
            }
            this.scoreIndustry = this.levelIndustry;
            this.scoreSize = this.levelSize;
            this.levelIndustry = parseFloat(this.scoreIndustry / 168.1 * 5.0).toFixed(2);
            this.levelSize = parseFloat(this.scoreSize / 168.1 * 5.0).toFixed(2);
            console.log("Loaded the result successfully.");
          })
          .catch((e) => {
            this.error = true;
            console.error("Error while loading result: " + e);
            this.isLoading = false;
          });
      } else {
        this.error = true;
        this.isLoading = false;
        console.error("Error while loading result: Code too short.");
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/company/kirc/result/kircres2.js